import { render, staticRenderFns } from "./passenger_bookings.vue?vue&type=template&id=267142ca&scoped=true"
import script from "./passenger_bookings.vue?vue&type=script&lang=js"
export * from "./passenger_bookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267142ca",
  null
  
)

export default component.exports